//libs
import React, { FC, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

import {
  Main,
  MainContent,
  NewsWrap,
  Wrap,
  WrapSP,
} from 'modules/main/pages/styles/HomePage/style';

// UI
import { LoadAnchor } from 'ui/LoadAnchor';

// Layouts
import { SiteWrap } from 'modules/main/layouts/SiteWrap';

// Components
import { NewCard } from 'modules/main//components/NewCard';
import { SectionTitle } from 'modules/main/components/SectionTitle';

//types
import { HomePageLayoutPropsType } from 'types/pages/HomePage';

// Hooks
import { useTranslations } from 'languages';

//api
import { useHomePage } from './hooks/useHomePage';
import { useInView } from 'react-intersection-observer';

const ContentBanner = dynamic(() => import('modules/main/components/ContentBanner'), {
  ssr: false,
});

const SpecialProjects = dynamic(() => import('modules/main/layouts/SpecialProjects'), {
  ssr: false,
});

const Videos = dynamic(() => import('modules/main/components/Videos'), {
  ssr: false,
});

const BeautyPediaForHomePage = dynamic(
  () => import('modules/main/layouts/BeautyPediaForHomePage'),
  {
    ssr: false,
  }
);
const ArticlesWithAuthorHome = dynamic(
  () => import('modules/main/layouts/ArticlesWithAutor/ArticleWithAuthorHomePage'),
  {
    ssr: false,
  }
);

export const HomePageLayout: FC<HomePageLayoutPropsType> = ({
  siteText,
  metaForHomePage,
}) => {
  const t = useTranslations();

  const {
    arrayWithTopSalePosts,
    modulId,
    anchorRef,
    deviceWidth,
    isLoading,
    isLoadingTopPosts,
  } = useHomePage();

  const [ref, inView] = useInView();

  const [isLoadOtherContent, setLoadOtherContent] = useState(false);
  const [addTransition, setTransition] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTransition(true);
    }, 2000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (inView && addTransition) {
      setLoadOtherContent(true);
    }
  }, [inView]);

  return (
    <SiteWrap
      articleMeta={metaForHomePage}
      isLoadOtherContent={isLoadOtherContent}
      anons={''}
    >
      <Main siteText={siteText}>
        <MainContent>
          <NewsWrap>
            {!isLoading && !isLoadingTopPosts && (
              <>
                {arrayWithTopSalePosts.map((data, i) => {
                  return (
                    <React.Fragment key={i}>
                      {i === 0 && (
                        <NewCard
                          // @ts-ignore
                          className="firstPost"
                          isPriority
                          data={data}
                        />
                      )}
                      {i === 1 && (
                        <NewCard
                          // @ts-ignore
                          className="firstPost"
                          isPriority
                          data={data}
                        />
                      )}
                      {i > 1 && <NewCard data={data} isLazyLoad />}
                      {i === 1 && deviceWidth < 540 && (
                        <div style={{ marginTop: '-60px' }} ref={ref}></div>
                      )}
                      {i === 5 && (
                        <>
                          <Wrap>
                            <div className="test" ref={ref}></div>
                            {isLoadOtherContent && (
                              <>
                                <ContentBanner
                                  modulId={modulId}
                                  isMainPage
                                  count="numberBannerFirst"
                                />
                                <WrapSP>
                                  <SectionTitle>{t('specialProjects')}</SectionTitle>
                                  <SpecialProjects />
                                </WrapSP>
                                <ContentBanner
                                  isMainPage
                                  modulId={modulId}
                                  count="numberBannerSecond"
                                />
                              </>
                            )}
                          </Wrap>
                        </>
                      )}
                      {i === 13 && isLoadOtherContent && (
                        <>
                          <ArticlesWithAuthorHome />
                          <SectionTitle>{t('Video')}</SectionTitle>
                          <Videos />
                        </>
                      )}
                      {i === 21 && isLoadOtherContent && (
                        <BeautyPediaForHomePage modulId={modulId} />
                      )}
                    </React.Fragment>
                  );
                })}
              </>
            )}
          </NewsWrap>
          {isLoadOtherContent && <LoadAnchor ref={anchorRef} />}
        </MainContent>
      </Main>
    </SiteWrap>
  );
};
